














































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import info from "@/info";
import Formulario from "@/components/Formulario.vue";


@Component({
  components: {
    Formulario,
  },
})
export default class Navbar extends Vue {
  public carsInfo: Array<object> = [];
  public autoName: string = "";
  public aIndex: object = {};

    scrollState(state: string) {
      const elem = document.getElementById("scrollBlock");
      elem!.style.overflow = state;
    }
  
    Activo(){
      const idDiv = document.getElementById("uk-navbar-dropdown-id");
      const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
      if (idDiv) {
        idDiv.style.display = (idDiv.style.display === "none" || idDiv.style.display === "") ? "block" : "none";}
      if (idDivModel) {
        idDivModel.style.display = "none";}
    }

    Activoml(){
      const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
      const idDiv = document.getElementById("uk-navbar-dropdown-id");
      if (idDivModel) {
        idDivModel.style.display = (idDivModel.style.display === "none" || idDivModel.style.display === "") ? "block" : "none";}
      if (idDiv) {
        idDiv.style.display =  "none";}
    }
    openMenuForm21(): void {


    let curtainForm = document.getElementById("curtain-formH2-1");
    let menuForm = document.getElementById("menu-formH2-1");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-formH2-1");
    menuForm?.classList.add("open-menu-formH2-1");

  }
  closeMenuForm21() {

    let curtainForm = document.getElementById("curtain-formH2-1");
    let menuForm = document.getElementById("menu-formH2-1");

    if (curtainForm) {
      curtainForm.style.display = "none";
    }
    menuForm?.classList.remove("open-menu-formH2-1");
    menuForm?.classList.add("disable-menu-formH2-1");
  }


  mounted() {
    this.carsInfo = info.home.headerSlider;
    this.autoName = this.$route.query.variableNavName as string;
    for (let i in info.home.headerSlider) {
        if (info.home.headerSlider[i].name === this.autoName) {
        this.aIndex = info.home.headerSlider[i];
        }
    }
  }

  openMenuForm() {
    this.aIndex == null? this.aIndex: this.aIndex = info.home.headerSlider[0];
    this.autoName = this.$route.query.variableNavName as string;
    for (let i in info.home.headerSlider) {
        if (info.home.headerSlider[i].name === this.autoName) {
        this.aIndex = info.home.headerSlider[i];
        }
    }
    const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
    const idDiv = document.getElementById("uk-navbar-dropdown-id");

    if (idDivModel) {
        idDivModel.style.display = "none";}
    if (idDiv) {
      idDiv.style.display =  "none";}

    let curtainForm = document.getElementById("curtain-form");
    let menuForm = document.getElementById("menu-form");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-form");
    menuForm?.classList.add("open-menu-form");
  }
  closeMenuForm() {
    let curtainForm = document.getElementById("curtain-form");
    let menuForm = document.getElementById("menu-form");

    if (curtainForm) {
      curtainForm.style.display = "none";
    }
    menuForm?.classList.remove("open-menu-form");
    menuForm?.classList.add("disable-menu-form");
  }

  openMenuMobile() {
    this.scrollState('hidden');
    let curtain = document.getElementById("curtain");
    let menu = document.getElementById("menu-mobile");

    if (curtain) {
      curtain.style.display = "block";
    }
    menu?.classList.remove("disable-menu-mobile");
    menu?.classList.add("open-menu-mobile");
  }
  closeMenuMobile() {
    this.scrollState('auto');
    let curtain = document.getElementById("curtain");
    let menu = document.getElementById("menu-mobile");

    if (curtain) {
      curtain.style.display = "none";
    }
    menu?.classList.remove("open-menu-mobile");
    menu?.classList.add("disable-menu-mobile");
  }
  openMenuMobile2() {
    this.scrollState('hidden');
    let curtain2 = document.getElementById("curtain2");
    let menu2 = document.getElementById("menu-mobile2");

    if (curtain2) {
      curtain2.style.display = "block";
    }
    menu2?.classList.remove("disable-menu-mobile2");
    menu2?.classList.add("open-menu-mobile2");
  }
  closeMenuMobile2() {
    this.scrollState('auto');
    let curtain = document.getElementById("curtain2");
    let menu = document.getElementById("menu-mobile2");

    if (curtain) {
      curtain.style.display = "none";
    }
    menu?.classList.remove("open-menu-mobile2");
    menu?.classList.add("disable-menu-mobile2");
  }
}

